import React, {useContext, useState, useEffect} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import StyleContext from "../../contexts/StyleContext";
import usePortfolio from "../../hooks/usePortfolio";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  const {greeting} = usePortfolio();
  const [showFace, setShowFace] = useState(false);
  const [isJumping, setIsJumping] = useState(false);
  const [isFlipping, setIsFlipping] = useState(false);

  useEffect(() => {
    // Trigger jump animation on page load
    let timer2;
    const timer1 = setTimeout(() => {
      setIsJumping(true);
      // Reset jump state after animation completes (1200ms)
      timer2 = setTimeout(() => {
        setIsJumping(false);
      }, 1200);
    }, 500); // Small delay to ensure the component is rendered

    return () => {
      clearTimeout(timer1);
      if (timer2) clearTimeout(timer2);
    };
  }, []);

  const onClickImage = () => {
    setIsFlipping(true);
    // Change image at the midpoint of the flip (when it's 90 degrees and not visible)
    setTimeout(() => {
      setShowFace(!showFace);
    }, 300); // Halfway through the 600ms animation
    setTimeout(() => {
      setIsFlipping(false);
    }, 600); // End of flip animation
  }

  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text={greeting.contactMe} href="#contact" />
                {greeting.resumeLink && (
                  <a
                    href={greeting.resumeLink}
                    target={"_blank"}
                    rel="noopener noreferrer"
                    download="Resume.pdf"
                    className="download-link-button"
                  >
                    <Button text={greeting.downloadMyResume} />
                  </a>
                )}
              </div>
            </div>
          </div>
          <div
            className={`greeting-image-div ${isJumping ? 'jump' : ''} ${isFlipping ? 'flip' : ''}`}
            onClick={onClickImage}
          >
            <img
                alt="My face"
                src={showFace ? require("../../assets/images/ddr.png") : require("../../assets/images/memoji.png")}
            />
          </div>
        </div>
      </div>
    </Fade>
  );
}
